module.exports = __webpack_public_path__ + "static/apple-icon-180x180-a6b972dc7dfbda374479d3273a56fccb.png";